import Ajax from '../common/ajax'

export default {
  model: 'examineeAuth',
  getPage (param) {
    return Ajax.post(`/api/gradeMaster/v1/${this.model}/page`, param)
  },
  setPage (param) {
    return Ajax.post(`/api/gradeMaster/v1/${this.model}/audit`, param)
  },
  getInfo (id) {
    return Ajax.get(`/api/gradeMaster/v1/${this.model}/info/${id}`)
  },
  updatePage (param) {
    return Ajax.post(`/api/gradeMaster/v1/${this.model}/update`, param)
  },
  getdescribeVerifyPage (param) {
    return Ajax.post(`/api/gradeMaster/v1/describeVerifyAppeal/page`, param)
  },
  getdescribeVerifyInfo (id) {
    return Ajax.get(`/api/gradeMaster/v1/describeVerifyAppeal/detail/${id}`)
  },
  describeVerifyAgree (id) {
    return Ajax.get(`/api/gradeMaster/v1/describeVerifyAppeal/agree/${id}`)
  },
  describeVerifyReject (param) {
    return Ajax.post(`/api/gradeMaster/v1/describeVerifyAppeal/reject`, param)
  },
  describeVerifyFaceCompare (param) {
    return Ajax.post(`/api/gradeMaster/v1/describeVerifyAppeal/faceCompare`, param)
  }
}
